interface RegenerateContentPayload {
  contentId: string;
  tone: string;
}

export function useContentRegenerate() {
  const mutation = useMutation({
    mutationFn: async (payload: RegenerateContentPayload) => {
      const { data } = await usePutRequest<{
        regeneratedContent: string;
      }>("content/regenerate", payload);
      return data.regeneratedContent;
    },
  });

  return mutation;
}
